/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

export function list(param) {
  return request(`${config.server}/api/v1/dms/product/listPc`, {
    method: 'post',
    body: {...param},
  });
}
export function add(param) {
  /*
   {
   name (string, optional): 渠道名称 ,
   code (string, optional): 渠道编号 ,
   shortName (string, optional): 渠道简称,
   parentId (integer, optional): 上级渠道 ,
   rank (integer, optional): 等级.青铜、白银、黄金、钻石 ,
   channelType (integer, optional): 渠道类型.销售公司、代理商、经销商、分销商 ,
   contacts (string, optional): 联系人 ,
   contactsMobile (string, optional): 联系人手机 ,
   province (string, optional): 省份 公司地址,
   city (string, optional): 城市 公司地址,
   county (string, optional): 区县 公司地址,
   address (string, optional): 详细地址 ,
   areaId (integer, optional): 归属区域 ,
   employeeId (integer, optional): 所属业务员 ,
   productTypeIdList (Array[integer], optional): 产品类别ID集合 ,
   areaIdList (Array[integer], optional): 销售地区ID集合 ,
   compnyPhone (string, optional): 公司电话 ,
   companyFax (string, optional): 公司传真 ,
   employeeNum (integer, optional): 公司员工数量 ,
   companyWebsite (string, optional): 公司网站 ,
   companyCeo (string, optional): CEO ,
   companyIncome (number, optional): 公司年收入 ,
   }
   **/
  return request(`${config.server}/api/v1/dms/channel/save`, {
    method: 'post',
    body: param,
  });
}
export function update(param) {
  /*
   {
   id (integer, optional): 渠道ID, 修改数据是传入
   name (string, optional): 渠道名称 ,
   code (string, optional): 渠道编号 ,
   shortName (string, optional): 渠道简称,
   parentId (integer, optional): 上级渠道 ,
   rank (integer, optional): 等级.青铜、白银、黄金、钻石 ,
   channelType (integer, optional): 渠道类型.销售公司、代理商、经销商、分销商 ,
   contacts (string, optional): 联系人 ,
   contactsMobile (string, optional): 联系人手机 ,
   province (string, optional): 省份 公司地址,
   city (string, optional): 城市 公司地址,
   county (string, optional): 区县 公司地址,
   address (string, optional): 详细地址 ,
   areaId (integer, optional): 归属区域 ,
   employeeId (integer, optional): 所属业务员 ,
   productTypeIdList (Array[integer], optional): 产品类别ID集合 ,
   areaIdList (Array[integer], optional): 销售地区ID集合 ,
   compnyPhone (string, optional): 公司电话 ,
   companyFax (string, optional): 公司传真 ,
   employeeNum (integer, optional): 公司员工数量 ,
   companyWebsite (string, optional): 公司网站 ,
   companyCeo (string, optional): CEO ,
   companyIncome (number, optional): 公司年收入 ,
   }
   **/
  return request(`${config.server}/api/v1/dms/channel/update`, {
    method: 'post',
    body: param,
  });
}
export function detail(param) {
  return request(`${config.server}/api/v1/dms/channel/detail?id=${param}`, {
    method: 'post',
  });
}

export function detail2(param) {
  return request(`${config.server}/api/v1/dms/employee/secondDetail/${param}`);
}

//渠道列表（提供给下拉框）
export function getListSelect(param) {
  return request(`${config.server}/api/v1/dms/channel/getListSelect`);
}


// WEBPACK FOOTER //
// ./src/service/channel/index.js